import React, { Fragment, useState } from 'react';
import { useEffect } from 'react';

export function Checkbox({ checked, onChange }) {
  const [isChecked, setIsChecked] = useState(checked)

  function onChangeCheckbox() {
    setIsChecked(!isChecked)
    onChange()
  }

  useEffect(() => {
    setIsChecked(checked)
  }, [checked])

  return (
    <input
      type="checkbox"
      defaultChecked={isChecked}
      checked={isChecked}
      onChange={onChangeCheckbox}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/Checkbox/index.js